import { render, staticRenderFns } from "./Warehouse.vue?vue&type=template&id=7c07d623&scoped=true&"
import script from "./Warehouse.vue?vue&type=script&lang=js&"
export * from "./Warehouse.vue?vue&type=script&lang=js&"
import style0 from "./Warehouse.vue?vue&type=style&index=0&id=7c07d623&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c07d623",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VRow,VSpacer,VTab,VTabs})
